var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 20 20",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,2.4H12.83a2.87,2.87,0,0,0-5.66,0H3.9A2.34,2.34,0,0,0,1.5,4.68V4.8A2.29,2.29,0,0,0,3,6.92V17.71A2.35,2.35,0,0,0,5.43,20h9.15A2.36,2.36,0,0,0,17,17.72h0V6.92A2.29,2.29,0,0,0,18.5,4.8V4.68A2.34,2.34,0,0,0,16.1,2.4ZM10,1.09A1.69,1.69,0,0,1,11.68,2.4H8.32A1.69,1.69,0,0,1,10,1.09Zm5.83,16.62a1.23,1.23,0,0,1-1.26,1.2H5.42a1.23,1.23,0,0,1-1.25-1.2V7.08H15.83ZM17.36,4.8A1.23,1.23,0,0,1,16.1,6H3.9A1.23,1.23,0,0,1,2.64,4.8V4.68A1.23,1.23,0,0,1,3.9,3.5H16.1a1.24,1.24,0,0,1,1.26,1.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94,17.53A.56.56,0,0,0,7.52,17V10.89a.58.58,0,0,0-.63-.53.57.57,0,0,0-.51.53V17A.55.55,0,0,0,6.94,17.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17.53a.55.55,0,0,0,.57-.53V10.89a.57.57,0,1,0-1.14,0V17A.55.55,0,0,0,10,17.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06,17.53a.55.55,0,0,0,.56-.53V10.89a.57.57,0,0,0-.62-.53.59.59,0,0,0-.52.53V17A.56.56,0,0,0,13.06,17.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5a4c919390052c2c50f9f15697d71c15.svg";
export { ForwardRef as ReactComponent };